export default "__VITE_ASSET__CpMLsiIo__"